export const EMAIL_TEMPLATE_PERMISSIONS = {
  EMAIL_TEMPLATE: 'EMAIL_TEMPLATE',
};
